<template>
  <div>
    <div class="header-toolbar flex flex-between flex-align-center">
      <div class="header-toolbar__buttons flex">
        <div class="buttons-group flex">
          <button-default class="chevron-left" @click="handleCalendarControls('prev')">
            <icon-default icon="left"/>
          </button-default>
          <button-default class="chevron-right" @click="handleCalendarControls('next')">
            <icon-default icon="right"/>
          </button-default>
        </div>

        <button-default @click="handleCalendarControls('today')">
          Today
        </button-default>
      </div>

      <div class="header-toolbar__title">
        <h2 v-if="calendarApi">{{ calendarApi.view.title }}</h2>
      </div>
    </div>

    <template v-if="pastDueItems.length">
      <p class="timeframe-title text-uppercase past_due">
        <icon-default icon="past-due"></icon-default>
        Past Due
      </p>

      <lazy-render
        v-for="item in pastDueItems"
        :key="item.id"
        :min-height="50"
        unrender
        class="mb-100"
      >
        <up-next-task-item v-if="item.class_name === MODELS.Task.class_name" :store-task="item" @edit="openTaskModal"/>

        <up-next-appointment-item v-if="item.class_name === MODELS.Appointment.class_name" :appointment="item"/>
      </lazy-render>
    </template>

    <template v-if="todayItems.length">
      <p class="timeframe-title text-uppercase today">
        <icon-default icon="today"></icon-default>
        Due Today
      </p>

      <lazy-render
        v-for="item in todayItems"
        :key="item.id"
        :min-height="50"
        unrender
        class="mb-100"
      >
        <up-next-task-item v-if="item.class_name === MODELS.Task.class_name" :store-task="item" @edit="openTaskModal"/>

        <up-next-appointment-item v-if="item.class_name === MODELS.Appointment.class_name" :appointment="item"/>
      </lazy-render>
    </template>

    <template v-if="tomorrowItems.length">
      <p class="timeframe-title text-uppercase">
        <icon-default icon="upcoming"></icon-default>
        Due Tomorrow
      </p>

      <lazy-render
        v-for="item in tomorrowItems"
        :key="item.id"
        :min-height="50"
        unrender
        class="mb-100"
      >
        <up-next-task-item v-if="item.class_name === MODELS.Task.class_name" :store-task="item" @edit="openTaskModal"/>

        <up-next-appointment-item v-if="item.class_name === MODELS.Appointment.class_name" :appointment="item"/>
      </lazy-render>
    </template>

    <template v-if="upcomingItems.length">
      <p class="timeframe-title text-uppercase">
        <icon-default icon="upcoming"></icon-default>
        Upcoming
      </p>

      <lazy-render
        v-for="item in upcomingItems"
        :key="item.id"
        :min-height="50"
        unrender
        class="mb-100"
      >
        <up-next-task-item v-if="item.class_name === MODELS.Task.class_name" :store-task="item" @edit="openTaskModal"/>

        <up-next-appointment-item v-if="item.class_name === MODELS.Appointment.class_name" :appointment="item"/>
      </lazy-render>
    </template>

    <!-- Task Modal -->
    <modal-container>
      <modal-crud-form
        ref="taskModal"
        title="Task"
        form-component="task-form"
        is-double-column
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import UpNextAppointmentItem from "./components/UpNextAppointmentItem.vue";
import dates from "../../services/dates";
import UpNextTaskItem from "./components/UpNextTaskItem.vue";
import LazyRender from "../../components/LazyRender.vue";

export default {
  name: "UpNextListDesktop",
  components: {
    LazyRender,
    UpNextTaskItem,
    UpNextAppointmentItem,
  },
  props: {
    calendarApi: null
  },
  computed: {
    tasks() {
      return this.$store.getters["upNext/incompleteTasks"];
    },
    appointments() {
      return this.$store.getters["upNext/pendingAppointments"];
    },
    tasksAndAppointments() {
      return [...this.tasks, ...this.appointments];
    },
    pastDueItems() {
      return dates.returnItemsBeforeToday(this.tasksAndAppointments, 'start_at');
    },
    todayItems() {
      return dates.returnItemsForToday(this.tasksAndAppointments, 'start_at');
    },
    tomorrowItems() {
      return dates.returnItemsForTomorrow(this.tasksAndAppointments, 'start_at');
    },
    upcomingItems() {
      return dates.returnItemsForAfterTomorrow(this.tasksAndAppointments, 'start_at');
    },
  },
  methods: {
    handleCalendarControls(event) {
      this.$emit('control', event);
    },
    openTaskModal(task) {
      this.$refs.taskModal.open(task);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables/variables";
.header-toolbar {
  &__buttons {
    :hover {
      background-color: $button-active;
      border-color: transparent;
    }

    .buttons-group {
      margin-right: 0.75em;

      .chevron-left {
        border-radius: 2px 0 0 2px !important;
      }

      .chevron-right {
        border-radius: 0 2px 2px 0 !important;
      }
    }

    button {
      padding: 0.3em 0.7em;
      font-size: 0.85rem;
    }
  }

  &__title {
    h2 {
      padding: 0 0.75rem;
      color: rgba(55, 59, 60, 0.7);
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }
}

.timeframe-title {
  margin: 20px 0;
  font-size: 1.2rem;
  font-weight: bold;

  &:first-child {
    margin-top: 0;
  }

  i {
    vertical-align: bottom;
  }

  &.past_due {
    color: $red;
  }

  &.today {
    color: $yellow;
  }
}
</style>
